import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { CompanyService, UserCompaniesScope } from './company.service';
import { DataService } from './data.service';

/**
 * Loads the companies the user is linked to into the shared lists (`ownCompanies$` / `linkedCompanies$`).
 * It is the only place that writes them: screens that filter companies keep their own local list.
 */
@Injectable({
  providedIn: 'root'
})
export class UserCompaniesService {
  private companyService = inject(CompanyService);
  private dataService = inject(DataService);

  /** companies the user is linked to in this build, as reported by the API (not only the ones loaded) */
  readonly total = signal(0);
  /** true when the API cut the list, so the shared lists hold only part of the user's companies */
  readonly truncated = signal(false);

  /** Mekanic build never lists brand/Makena companies, and the Makena build lists only them */
  get scope(): UserCompaniesScope {
    return environment.makena ? 'makena' : 'mekanic';
  }

  async reload(): Promise<void> {
    const user = this.dataService.user;
    if (!user) {
      return;
    }
    const { companies, total, truncated } = await this.companyService.list({ scope: this.scope });
    user.defineCompanies(companies);
    this.total.set(total);
    this.truncated.set(truncated);
  }
}
